import { WIDGET_CLASS } from '../constants';

export function isElementInsideWidget(element: HTMLElement): boolean {
  let currentElement: HTMLElement | null = element;

  while (currentElement) {
    if (currentElement.classList.value.includes(WIDGET_CLASS)) {
      return true;
    }
    currentElement = currentElement.parentElement;
  }

  return false;
}
